import { withNamespaces } from "react-i18next";
import React, { useMemo } from "react";
import { Col, Container, Row } from "reactstrap";
import PageBody from "../../../components/page-body";
import Navigator from "../../../../../components/navigator";
import ListToms from "./pages/list-toms";

const TOMS = ({ t }) => {
  const navigatorOptions = useMemo(() => {
    return {
      enable: true,
      breadCrumbs: [
        {
          title: "SIP",
          link: `/admin/data-protection/dashboard`,
        },
        {
          title: "TOM",
          link: `/admin/data-protection/toms`,
        },
      ],
    };
  }, []);

  return (
    <div className="page-content">
      <Container fluid>
        <Row>
          <Col lg="12" className="mb-4">
            <Navigator {...navigatorOptions} pageTitle={t("TOM")} />
          </Col>
        </Row>

        <PageBody>
          <div className="p-4 mb-5">
            <ListToms />
          </div>
        </PageBody>
      </Container>
    </div>
  );
};

export default withNamespaces()(TOMS);
